import Mixin from '../Mixin';
import FDictionaryServiceAdditional from '@/modules/Dictionary/ServiceAdditional/Select';
import FDictionaryServiceDescription1 from '@/modules/Dictionary/ServiceDescription1/Select';
import FDictionaryServiceDescription2 from '@/modules/Dictionary/ServiceDescription2/Select';

import component from './component.vue';

export default class extends Mixin {
  component = component;

  additional = new FDictionaryServiceAdditional({
    label: 'Доп.услуги в отеле',
    required: true,
  });

  description1 = new FDictionaryServiceDescription1({
    label: 'Описание 1',
  });

  description2 = new FDictionaryServiceDescription2({
    label: 'Описание 2',
  });

  constructor(props) {
    super(props);
    this.service.set({
      value: 8,
      label: 'Доп.услуги в отеле',
    });
    this.setItems([
      ['additional', this.additional],
      ['description1', this.description1],
      ['description2', this.description2],
    ]);
    this.additional.service = this.service;
    this.additional.country = this.country;
    this.description1.service = this.service;
    this.description2.service = this.service;
  }


  set(value = {}) {
    super.set(value);
    this.__set('additional', value.additional, null);
    this.__set('description1', value.description1, null);
    this.__set('description2', value.description2, null);
    return this;
  }

  toString() {
    return this.additional.toString();
  }

  submit() {
    return super.submit()
      .then((data) => {
        this.name = this.additional.toLabel();
        return data;
      });
  }
}
